import React, { useEffect, useState } from 'react';
import { animate, useReducedMotion } from 'framer-motion';

export interface CountUpProps {
  value: number;
  duration?: number;
  suffix?: string;
}

/* A number that climbs to its value once, and again whenever the value changes. */
export const CountUp: React.FC<CountUpProps> = ({ value, duration = 0.7, suffix = '' }) => {
  const reduce = useReducedMotion();
  const [shown, setShown] = useState(reduce ? value : 0);

  useEffect(() => {
    if (reduce) {
      setShown(value);
      return undefined;
    }
    const controls = animate(0, value, {
      duration,
      ease: [0.22, 1, 0.36, 1],
      onUpdate: (v) => setShown(Math.round(v)),
    });
    return () => controls.stop();
  }, [value, duration, reduce]);

  return <span className="tabular-nums">{shown}{suffix}</span>;
};
